























import { defineComponent } from '@nuxtjs/composition-api';
import useUiNotification from '@shared/composables/useUiNotification';
import { BaseNotification, UCIcon } from '@shared/ui';

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Notification',
  components: {
    BaseNotification,
    UCIcon,
  },
  setup() {
    const { notifications } = useUiNotification();

    return {
      notifications,
    };
  },
});
